import { render, staticRenderFns } from "./projects-table.vue?vue&type=template&id=14809e14&scoped=true&"
import script from "./projects-table.vue?vue&type=script&lang=js&"
export * from "./projects-table.vue?vue&type=script&lang=js&"
import style0 from "./projects-table.vue?vue&type=style&index=0&id=14809e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14809e14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
